module.exports = __webpack_public_path__ + "img/svg/ps5.542e382fe422f0c901dd9cddc1698b97.svg";